



































import Vue from 'vue'
import { IPersonBase } from '@/api/types/response.types'

export default Vue.extend({
  name: 'Avatar',

  props: {
    person: {
      type: Object as () => IPersonBase,
      default: null,
    },
    size: {
      type: Number,
      default: 32,
    },
    showNameOnHover: {
      type: Boolean,
      default: false,
    },
    /* Prepends to the name for the hover and title states */
    namePrefix: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      backgroundColorCircle: [
        'bluey-purple',
        'darkish-pink',
        'reddish-orange',
        'light-orange',
        'dodger-blue',
        'algae-green',
        'bluish-grey',
      ],
    }
  },

  computed: {
    isAnonymous(): boolean {
      if (this.person && this.person.id !== 0) {
        return false
      }
      return true
    },
    personName(): string {
      return this.isAnonymous ? 'Unassigned' : this.person.name
    },
    firstLetter(): string {
      if (this.isAnonymous || this.person.photoUrl) {
        return ''
      }

      if (this.person.name) {
        return this.person.name[0].toUpperCase()
      }

      return ''
    },

    customStyle(): Object {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderRadius: '50%',
      }
    },

    photoStyle(): Object {
      return {
        backgroundImage: 'url(' + this.person.photoUrl + ')',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }
    },

    fontStyle(): Object {
      return {
        fontSize: this.size / 1.5 + 'px',
        fontWeight: 500,
        color: '#fff',
      }
    },

    hasImage(): Boolean {
      return this.isAnonymous ? false : Boolean(this.person.photoUrl)
    },

    backgroundColorClass(): String {
      if (this.isAnonymous) {
        return 'avatar--is-anonymous'
      }
      if (this.hasImage) {
        return 'avatar--white'
      }
      const colors = this.backgroundColorCircle
      return 'avatar--' + this.randomBackgroundColor(colors)
    },
  },

  methods: {
    randomBackgroundColor(colors: String[]) {
      const letters = this.person.name.split('') // get string as an array of chars
      // Sum all ASCII letter codes
      const seed = letters.reduce((acc, value) => {
        return acc + value.charCodeAt(0)
      }, 0)

      return colors[seed % colors.length]
    },
  },
})
